import { render } from "./VTruncateText.vue?vue&type=template&id=4c802a2d"
import script from "./VTruncateText.vue?vue&type=script&lang=js"
export * from "./VTruncateText.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__